export default (arr, func) => arr.forEach(obj => func(obj))
